<template>
    <div id="ContainerAuditSettingList">
        <div class="row">
            <div class="col-12">
                <MdTitle v-bind:Text= "$t('AuditSettingsList.AuditSettingsTitle')"/>
                <div class="row">
                    <div class="col-sm-12 col-md-12 mb-12">
                        <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                            <div class="input-group">
                                <input 
                                    type="text" 
                                    class="form-control"
                                    v-model="paramAudits.SearchCriteria"
                                    @keyup.enter="SearchAuditSettings()"
                                >
                                <div class="input-group-append">
                                    <MdButton 
                                        v-bind:Name="'btnsearchinput'"
                                        v-bind:VariantProp="'btn btn-sm search-attached'"
                                        v-bind:IconClass="'mdi mdi-magnify'"
                                        v-on:click="SearchAuditSettings()">
                                    </MdButton>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <div>
                    <MdTitle v-bind:Text="$t('Shared.SearchResult')" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>
                    <MdTable
                        v-bind:fields="fields"
                        v-bind:items="items"
                        v-bind:totalRows="totalRows"
                        v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
                        v-bind:currentPage="currentPage"
                        v-bind:perPage="perPage"
                        v-bind:pageOptions="pageOptions"
                        v-bind:refTable="refTable"
                        v-bind:VisibleEditIcon="true"
                        :editIconEvent="GoToAuditSetting"
                        :pageChanged="pageChanged"
                        :perPageFunction="PerPageFunction">
                    </MdTable>
                </div>
            </div>
        </div>

        <div class="space-actions"></div>
        <div class="page-actions">
            <MdButton
                v-bind:Label="$t('Shared.Back')"
                v-bind:Name="'btnWebAudit'"
                v-bind:ClassProp="'secondary mx-2 btn-login'"
                v-on:click="goToWebAudit()"/>
        </div>

        <AuditSettingEditDialog
            v-bind:VisibleDialog="showEditDialog"
            v-model= "editItem"
            @close="handleClose"
        >
        </AuditSettingEditDialog>
    </div>
</template>

<script>
import ShowMessage from '@/components/messages/ShowMessage.js'
import DBFunctions from '@/common/DBFunctions.js'
import AuditSettingsService from '@/services/auditsettings.service' 
import AuditUtils from '@/components/pages/audit/AuditUtils.js'

export default {
    name: 'AuditSettingListing',
    mixins: [ShowMessage, DBFunctions],

    data() {
        return {
            OptionsRightMenu:{
                visible:false,
                ItemsList:[],
                btnvisible:false,
                itemdisabled: false,
                PatientCode:'',
                Mode:this.edit_mode,
                favButtonAtion:false          
            },
            ShowMessageIsEmpty:false,
            paramAudits:{
                SearchCriteria:'',
                PageNumber : 1,
                PageSize: 10,
            },
            fields: [
                { key: 'moduleTrans', sortable: true, label: this.$t('AuditList.Module'), class: 'text-rigth' },
                { key: 'auditInsertTranslated', sortable: false, label: this.$t('Shared.Add'), class: 'text-rigth' },
                { key: 'auditUpdateTranslated', sortable: false, label: this.$t('AuditSettingsList.Update'), class: 'text-rigth' },
                { key: 'auditDeleteTranslated', sortable: true, label: this.$t('Shared.Delete'), class: 'text-rigth' },
                { key: 'auditViewTranslated', sortable: false, label: this.$t('Shared.View'), class: 'text-rigth' },
                { key: 'auditLoginTranslated', sortable: false, label: this.$t('AuditSettingsList.Login'), class: 'text-rigth' },
                { key: 'auditLogoutTranslated', sortable: false, label: this.$t('AuditSettingsList.Logout'), class: 'text-rigth' },
            ],
            pageOptions: [5, 10, 15],
            totalRows: 0,
            currentPage: 1,
            perPage: 10,
            refTable: 'selectableTable',
            items: [],
            showEditDialog: false,
            editItem: null
        }
    },

    methods: {
        GoToAuditSetting(item) {
            this.editItem = item;
            this.showEditDialog = true;
        },

        SearchAuditSettings() {
            this.currentPage = 1;
            this.HandleSearchAudits();
        },

        HandleSearchAudits() {
            this.$emit('load', true);
            this.paramAudits.PageNumber = this.currentPage;
            AuditSettingsService.getAll(this.paramAudits)
                .then((response) => {
                    if(response.data){   
                        this.items = response.data;
                        this.items.forEach((element) => {  
                            element.moduleTrans = AuditUtils.translateModule(element.moduleCapitalized);   
                        });

                        let headerString = response.headers["x-pagination"];
                        const Header = JSON.parse(headerString);
                        this.totalRows = Header.TotalCount;
                    }

                    if (this.items.length === 0) {
                        this.ShowMessageIsEmpty = true;
                    }  
                    this.$emit('load', false);
                })
                .catch(error => {      
                    this.$emit('load', false);
                    this.showResponseErrorMessage(error);
                });
        },

        pageChanged (page) {            
            this.currentPage = page;
            this.HandleSearchAudits();
        },

        PerPageFunction(perpage){
            this.perPage = perpage;
            this.currentPage = 1;
            this.paramAudits.PageSize = this.perPage;
            this.HandleSearchAudits();
        },

        handleClose(refresh) {
            this.showEditDialog = false;

            if (refresh) {
                this.$emit('load', true);
                AuditSettingsService
                    .update(this.editItem.recId, this.editItem)
                    .then((response) => {
                        if (response.status == '200') { 
                            this.editItem.auditInsertTranslated = this.editItem.auditInsertTranslated == '' ? '' : this.editItem.auditInsert ? this.$t('Shared.TitleYes') : this.$t('Shared.TitleNo') ;
                            this.editItem.auditUpdateTranslated = this.editItem.auditUpdateTranslated == '' ? '' : this.editItem.auditUpdate ? this.$t('Shared.TitleYes') : this.$t('Shared.TitleNo') ;
                            this.editItem.auditDeleteTranslated = this.editItem.auditDeleteTranslated == '' ? '' : this.editItem.auditDelete ? this.$t('Shared.TitleYes') : this.$t('Shared.TitleNo') ;
                            this.editItem.auditViewTranslated = this.editItem.auditViewTranslated == '' ? '' : this.editItem.auditView ? this.$t('Shared.TitleYes') : this.$t('Shared.TitleNo') ;
                            this.editItem.auditLoginTranslated = this.editItem.auditLoginTranslated == '' ? '' : this.editItem.auditLogin ? this.$t('Shared.TitleYes') : this.$t('Shared.TitleNo') ;
                            this.editItem.auditLogoutTranslated = this.editItem.auditLogoutTranslated == '' ? '' : this.editItem.auditLogout ? this.$t('Shared.TitleYes') : this.$t('Shared.TitleNo') ;

                            setTimeout(() => 
                                this.$bvToast.toast(this.$t('Msg.SavedSuccessfully'), {
                                    title: this.$t('Msg.Success'),
                                    autoHideDelay: 3000,
                                    variant: "success"
                                }), 50); 
                        }
                        
                        this.$emit('load', false);
                        this.editItem = null;
                    })
                    .catch(error => {
                        this.showResponseErrorMessage(error);
                        
                        this.$emit('load', false);
                        this.editItem = null;
                    });
            }
        },

        goToWebAudit() {
            this.$router.push({ name: "auditListing"});
        }
    },

    async mounted() {
        //this.OptionsRightMenu.ItemsList = EnumService.ClinicalItems
        let layoutStatus = this.$store.state.layoutStatus;
        switch(layoutStatus) {
            case 'L0R1':
            this.OptionsRightMenu.favButtonAtion = true;
            this.$emit('getVisibleMenu', this.OptionsRightMenu);
            break;
            case 'L1R0':
            case 'L1R1':
                this.OptionsRightMenu.btnvisible = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
            break;
            default:
                this.OptionsRightMenu.favButtonAtion = true;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
        }  

        this.$emit('load', true);
        await this.SearchAuditSettings();
    }
}
</script>